import {AfterContentInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';

@Component({
    selector: 'ecp-step-page',
    templateUrl: './step-page.component.html',
    styleUrls: ['./step-page.component.css']
})
export class StepPageComponent implements  OnInit, AfterContentInit {
    @Output() event = new EventEmitter();
    @Input() title: string;
    @ViewChild('bodyTpl', {static: true}) content: TemplateRef<void>;


    constructor(private fb: FormBuilder) {
    }

    ngOnInit() {

    }


    ngAfterContentInit(): void {

    }


}
